import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["progressBorder", "countdown"];

  isActive = false; // Track if timer is currently running

  connect() {
    console.log("Spot timer controller connected");
    // Don't auto-start timer anymore - wait for power-up activation

    // Listen for custom events to start the timer
    this.element.addEventListener("spot-timer:start", () => {
      this.startTimer();
    });

    this.element.addEventListener("spot-timer:activate", () => {
      this.startTimer();
    });
  }

  startTimer() {
    // Prevent multiple timers from running
    if (this.isActive) {
      console.log("Timer already active, ignoring start request");
      return;
    }

    this.isActive = true;
    console.log("Starting Bird View timer");

    // Show the container
    this.element.classList.remove("hidden");
    this.element.style.display = "block";
    this.element.style.opacity = "1";
    this.element.style.transform = "scale(1)";

    // Force map to reinitialize after becoming visible
    setTimeout(() => {
      const mapElement = this.element.querySelector('[data-map-target="map"]');
      if (mapElement) {
        // Dispatch event to trigger map reinitialization
        mapElement.dispatchEvent(new CustomEvent("map:reinitialize"));
      }
    }, 200);

    // Additional reinitialize after a longer delay to ensure tiles load
    setTimeout(() => {
      const mapElement = this.element.querySelector('[data-map-target="map"]');
      if (mapElement) {
        mapElement.dispatchEvent(new CustomEvent("map:reinitialize"));
      }
    }, 500);

    // Start the progress animation using conic gradient
    this.animateProgress();

    // Start countdown
    this.timeLeft = 10;
    this.updateCountdown();

    // Update countdown every second
    this.countdownInterval = setInterval(() => {
      this.timeLeft--;
      this.updateCountdown();

      if (this.timeLeft <= 0) {
        this.hideMap();
      }
    }, 1000);

    // Hide map after 10 seconds
    setTimeout(() => {
      this.hideMap();
    }, 10000);
  }

  animateProgress() {
    let progress = 0;
    const duration = 10000; // 10 seconds
    const interval = 50; // Update every 50ms
    const step = (interval / duration) * 360; // Degrees per step

    const progressInterval = setInterval(() => {
      progress += step;
      if (progress >= 360) {
        progress = 360;
        clearInterval(progressInterval);
      }

      // Update the conic gradient with solid colors
      this.progressBorderTarget.style.background = `conic-gradient(from 0deg, #10B981 0deg, #10B981 ${progress}deg, rgba(255,255,255,0.3) ${progress}deg, rgba(255,255,255,0.3) 360deg)`;
    }, interval);
  }

  updateCountdown() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.timeLeft;
    }
  }

  hideMap() {
    // Clear the interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Reset active state
    this.isActive = false;
    console.log("Bird View timer ended");

    // Add fade out animation and hide
    this.element.style.transition =
      "opacity 0.5s ease-out, transform 0.5s ease-out";
    this.element.style.opacity = "0";
    this.element.style.transform = "scale(0.8)";

    // Remove from DOM after animation
    setTimeout(() => {
      this.element.style.display = "none";
      this.element.classList.add("hidden");
    }, 500);
  }

  disconnect() {
    // Clean up interval if controller is disconnected
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    // Reset active state
    this.isActive = false;
  }
}
 